import { useThemeContext } from '#contexts/ThemeContext';
import { Answer, QuestionnaireElements } from '#models/questionnaire';
import { Box, makeStyles, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';

interface MultipleAnswerProps {
  answer: Answer;
  showHelperText: any;
  selected?: boolean;
}

const useStyles = ({ answerCardSelectedState, isTouchDevice }: Partial<QuestionnaireElements>, isSmDown: Boolean) =>
  makeStyles((theme: any) => ({
    answerBox: {
      height: '100%',
      border: '1px solid transparent',
      cursor: 'pointer',
      maxWidth: '100%',
      '&:hover': {
        borderColor: isTouchDevice || isSmDown ? 'transparent' : answerCardSelectedState
      },
      [theme.breakpoints.up('xs')]: {
        width: 320
      }
    }
  }));

export const BooleanAnswer = ({ answer, showHelperText, selected }: MultipleAnswerProps) => {
  const themeMaterial = useTheme();
  const isSmDown = useMediaQuery(themeMaterial.breakpoints.down('sm'));
  const theme = useThemeContext();
  const classes = useStyles(theme, isSmDown)();

  return (
    <Box clone position='relative' display='flex' justifyContent='center' alignItems='center'>
      <Paper
        className={classes.answerBox}
        style={{
          borderColor: selected ? theme.answerCardSelectedState : undefined
        }}
      >
        <Box p={2}>
          <Typography style={{ color: theme.answerText }} variant='body2' align='center' className='semiBold'>
            {answer.text}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};
